import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ProductListingDictionary from '@/types/dictionaries/ProductListing';

interface ProductCountProps {
	count: number;
	dict: ProductListingDictionary;
}

const ProductCount = ({ count, dict }: Readonly<ProductCountProps>) => (
	<Box
		sx={{ pt: '32px', pb: '16px', borderBottom: '1px solid', borderColor: 'grey.light' }}
		data-testid="product-number-results"
	>
		<Typography variant="paragraphSemiBold">
			{count} {count === 1 ? dict.searchResults.result : dict.searchResults.results}
		</Typography>
	</Box>
);

export default ProductCount;
